import React, {useState, useEffect, useContext} from "react";
import Box from "@mui/material/Box";
import {getHeadersLimits} from '@api/barcodesLimit';
import benefitsApi from "@api/benefits";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {DataGrid} from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import {remove} from "@api/barcodesLimit";
import {Modal} from "@modal";
import {useLocation} from "react-router";
import {renderCellExpand} from "@components/renderCellExpand";
import {Pagination, Stack, Typography} from "@mui/material";
import {getState, updateHideColumnGridData, updateState} from "@services/state";
import {removeState} from "../../services/state";

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    button: {
        width: '100%',
        margin: '10px',
    }
});

const data = [
    {field: 'id', headerName: 'id', renderCell: renderCellExpand},
    {field: 'amount', headerName: 'amount', renderCell: renderCellExpand},
    {field: 'from', headerName: 'from', renderCell: renderCellExpand},
    {field: 'until', headerName: 'until', renderCell: renderCellExpand},
    {field: 'benefitName', headerName: 'Benefit name', renderCell: renderCellExpand}
];

export const BarcodesLimits = () => {
        const stateName = 'stateBarcodesLimit';

        const search = useLocation().search;
        const benefitId = new URLSearchParams(search).get('benefitId');

        const classes = useStyles();
        const {setLoading} = useContext(LoadingContext);
        const {setErrorMessage} = useContext(MessageContext);
        const [rows, setRows] = useState([]);
        const state = getState(stateName);
        const [sortModel, setSortModel] = useState(state && state.sort ? state.sort : []);
        const [headers, setHeaders] = useState();
        const [columns] = useState(updateHideColumnGridData(data, stateName));
        const [editBarcodesLimit, setEditBarcodesLimit] = useState({});
        const [openAddModal, setOpenAddModal] = useState(false);
        const [openUpdateModal, setOpenUpdateModal] = useState(false);

        const onUpdate = (id, row) => {
            const {benefitId, from, until} = row;
            setEditBarcodesLimit({id, from, until, benefitId})
            setOpenUpdateModal(!openUpdateModal);
        }

        columns.push({
            field: 'Update',
            headerName: 'Update',
            renderCell: (data) => {
                return <Button variant="outlined" onClick={() => onUpdate(data.id, data.row)}>Update</Button>;
            }
        })

        const onDelete = async (id) => {
            try {
                setLoading(true);
                setErrorMessage(null);
                await remove(id);
                await loadBarcodeLimit()
            } catch (e) {
                setErrorMessage(e);
            }
            setLoading(false);
        }

        columns.push({
            field: 'Delete',
            headerName: 'Delete',
            renderCell: ({id}) => {
                return <Button variant="outlined" onClick={() => onDelete(id)}>Delete</Button>;
            }
        })

        const addBarcodesLimit = () => {
            setEditBarcodesLimit({benefitId})
            setOpenAddModal(!openAddModal);
        }

        const reloadBenefits = async () => {

            setOpenAddModal(false);
            setOpenUpdateModal(false);
            await loadBarcodeLimit();
        }


        const loadBarcodeLimit = async () => {
            try {
                setLoading(true);
                setErrorMessage(null);
                const q = benefitId ? benefitId : null
                const state = getState(stateName);
                const page = state && state.page ? state.page - 1 : 0 ;
                const sort = state ? state.sort : {};
                const [barCodes, headers] = await getHeadersLimits({benefitId: q, page, sort});
                const [benefits] = await benefitsApi.get({})
                barCodes.forEach((barCode) => {
                    const currentBenefit = benefits.filter(benefit => benefit.id === barCode.benefitId)[0]
                    barCode.benefitName = currentBenefit ? currentBenefit.name : '';
                })
                headers.page *= 1;
                headers.pages *= 1;
                setHeaders(headers);
                setRows(barCodes);
            } catch (e) {
                setErrorMessage(e);
            }
            setLoading(false);
        }

        const onChangePage = async (e, value) => {
            try {
                e.preventDefault();
                setLoading(true);
                setErrorMessage(null);
                const q = benefitId ? benefitId : null
                const state = getState(stateName);
                const sort = state ? state.sort : {};
                const [body, headers] = await getHeadersLimits({benefitId: q, page: value - 1, sort});
                const [benefits] = await benefitsApi.get({})
                body.forEach((barCode) => {
                    const currentBenefit = benefits.filter(benefit => benefit.id === barCode.benefitId)[0]
                    barCode.benefitName = currentBenefit ? currentBenefit.name : '';
                })
                setRows([...body])
                headers.page *= 1;
                headers.pages *= 1;
                updateState({page: value}, stateName);

                setHeaders(headers);

            } catch (e) {
                setErrorMessage(e);
            }
            setLoading(false);
        }

        const resetLocalStorage = () => {
            removeState(stateName);
            window.location.reload();
        }

        const onStateChange = (e) => {
            updateState({columns: e.columns.lookup}, stateName);
        }

        const onSortModelChange = (e) => {
            setSortModel(e)
            updateState({sort: e}, stateName);
        }

        useEffect(() => {
            loadBarcodeLimit();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [sortModel])

        return (
            <Box
                className={classes.root}
                display={"flex"}
                flexDirection={'column'}
                alignItems={"center"}
            >
                {benefitId && <Box display={"flex"}
                                   justifyContent={"flex-end"}
                                   justifyItems={"flex-end"} className={classes.button}>
                    <Button variant="contained" onClick={addBarcodesLimit}>Add barcodes limit</Button>
                </Box>}

                <Box>
                </Box>
                <Box style={{height: 400, width: '100%'}}>
                    <DataGrid
                        autoHeight={true}
                        rows={rows}
                        columns={columns}
                        checkboxSelection
                        onStateChange={(e) => onStateChange(e)}
                        sortModel={sortModel}
                        onSortModelChange={(e) => onSortModelChange(e)}
                    />
                    <Stack spacing={2}>
                        {
                            headers?.pages && headers?.page ? (<><Typography>Page: {headers?.page}</Typography>
                                <Pagination count={headers?.pages} page={headers?.page} onChange={onChangePage}/>
                            </>) : ''
                        }
                    </Stack>
                    <Box display={"flex"}
                         justifyContent={"flex-end"}
                         justifyItems={"flex-end"}>
                        <Button variant="outlined" sx={{marginRight: 2, marginBottom: 2}} onClick={() => resetLocalStorage()}>Reset</Button>
                    </Box>
                </Box>
                {openAddModal && <Modal
                    isOpen={openAddModal}
                    data={editBarcodesLimit}
                    onClose={(data) => reloadBenefits(data)}
                    name='CreateBarcodesLimit'/>}
                {openUpdateModal && <Modal
                    isOpen={openUpdateModal}
                    data={editBarcodesLimit}
                    onClose={(data) => reloadBenefits(data)}
                    name='UpdateBarcodesLimit'/>}
            </Box>
        );
    }
;